import * as types from './types';
import { RESET_DATASET } from 'store/dataset/types';
import { RESET_GRAPHICAL_STATISTICS } from '../types';
import { FREQUENCY, RELATIVE_FREQUENCY } from 'scenes/GraphicalStatistics/SettingsForm/AdditionalFields/Component';

const initialState = {
  typeOfFrequencyHistogram: FREQUENCY,
  typeOfFrequencyBarChart: FREQUENCY,
  typeOfFrequencyPieChart: RELATIVE_FREQUENCY
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PRIMARY_PARAMETER_NAME:
      return { ...state, primary: action.parameterName };
    case types.SET_SECONDARY_PARAMETER_NAME:
      return { ...state, secondary: action.parameterName };
    case types.SET_TYPE_FREQUENCY_HISTOGRAM:
      return { ...state, typeOfFrequencyHistogram: action.typeOfFrequencyHistogram };
    case types.SET_TYPE_FREQUENCY_BAR_CHART:
      return { ...state, typeOfFrequencyBarChart: action.typeOfFrequencyBarChart };
    case types.SET_TYPE_FREQUENCY_PIE_CHART:
      return { ...state, typeOfFrequencyPieChart: action.typeOfFrequencyPieChart };
    case RESET_DATASET:
    case RESET_GRAPHICAL_STATISTICS:
      return initialState;
    default:
      return state;
  }
};
